export default "__VITE_ASSET__jydrkOmQ__"